// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__16Y5K","label":"LabeledBox_label__3B5_Z"};